import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { length } from '~/services/util';
import Course from './Course';

function List(props) {
    const { userRole, data, onModal, onToggle, onSelect } = props;

    return (
        <>
            <div className="d-flex py-2">
                <div className="d-flex-6 dsl-m12">Courses</div>
                <div className="d-flex-1 dsl-m12">Tracks</div>
                <div className="d-flex-1 dsl-m12">Modules</div>
                <div className="d-flex-1 dsl-m12">Assigned</div>
            </div>
            {data.map((course, index) => (
                <Course
                    key={`${course.id}-${index}`}
                    id={course.id}
                    userRole={userRole}
                    name={course?.data?.en?.name || ''}
                    description={course.data.en?.description || ''}
                    thumbnail={course.data.thumb_url}
                    modules={length(course.children)}
                    tracks={length(course.data.tracks)}
                    assigned={course.data.assigned}
                    published={course.published}
                    coursesCount={length(data)}
                    onModal={(e) => onModal(e)}
                    onDetail={() => onToggle(course.id, 'view')}
                    onSelect={(e) => onSelect(e, course)}
                />
            ))}
        </>
    );
}

List.propTypes = {
    userRole: PropTypes.number,
    data: PropTypes.array,
    onToggle: PropTypes.func,
};

List.defaultProps = {
    userRole: 1,
    data: [],
    onToggle: () => {},
};

export default memo(List);
